import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=3ff1a16d&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=3ff1a16d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1a16d",
  null
  
)

export default component.exports